import vi from './vi'
import en from './en'
import ja from './ja'

export const messages = {
  vi,
  en,
  ja,
}

export const defaultLocale = 'en'

export const supportedLocales = [
  { code: 'vi', name: 'Tiếng Việt', flag: '🇻🇳' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'ja', name: '日本語', flag: '🇯🇵' },
]
